import {
  notify
} from "./chunk-DL5QNKBI.js";
import {
  PAGE_STATUS
} from "./chunk-OSVSI4BW.js";
import {
  __publicField
} from "./chunk-JCO6WRHX.js";

// src/pages/Members/MemberViewModel/MemberListViewModel.ts
import { makeAutoObservable, runInAction } from "mobx";
import { ORGANISATION_MEMBER_FIELD } from "aesirx-lib";
import moment from "moment";
var MemberListViewModel = class {
  constructor(memberStore) {
    __publicField(this, "memberStore");
    __publicField(this, "formStatus", PAGE_STATUS.READY);
    __publicField(this, "memberListViewModel", {});
    __publicField(this, "items", []);
    __publicField(this, "filter", {});
    __publicField(this, "successResponse", {
      state: false,
      content_id: "",
      listPublishStatus: [],
      1: [],
      filters: {
        "list[limit]": 10
      },
      listMembers: [],
      pagination: null,
      listMembersWithoutPagination: []
    });
    __publicField(this, "setForm", (memberListViewModel) => {
      this.memberListViewModel = memberListViewModel;
    });
    __publicField(this, "initializeData", async () => {
      runInAction(() => {
        this.successResponse.state = false;
      });
      const data = await this.memberStore.getList(this.successResponse.filters);
      runInAction(() => {
        if (!data?.error) {
          this.onSuccessHandler(data?.response, "");
        } else {
          this.onErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "initializeAllData", async () => {
      runInAction(() => {
        this.successResponse.state = false;
      });
      const data = await this.memberStore.getListWithoutPagination(this.filter);
      runInAction(() => {
        if (!data?.error) {
          this.callbackOnSuccessGetMembersHandler(data?.response);
        } else {
          this.onErrorHandler(data?.response);
        }
        this.successResponse.state = true;
      });
    });
    __publicField(this, "getListByFilter", async (key, value) => {
      value ? this.successResponse.filters[key] = value : delete this.successResponse.filters[key];
      if (key != "list[start]" && key != "list[limit]") {
        delete this.successResponse.filters["list[start]"];
      } else {
        if (key == "list[limit]" && value * this.successResponse.pagination.page >= this.successResponse.pagination.totalItems) {
          this.successResponse.filters["list[start]"] = Math.ceil(this.successResponse.pagination.totalItems / value - 1) * value;
        } else if (key == "list[limit]" && value * this.successResponse.pagination.page < this.successResponse.pagination.totalItems) {
          this.successResponse.filters["list[start]"] = (this.successResponse.pagination.page - 1) * value;
        }
      }
      const data = await this.memberStore.getList(this.successResponse.filters);
      runInAction(() => {
        if (!data?.error) {
          this.onSuccessHandler(data?.response, "");
        } else {
          this.onErrorHandler(data?.response);
        }
        this.successResponse.state = true;
      });
    });
    __publicField(this, "onSuccessHandler", (result, message) => {
      if (result && message) {
        notify(message, "success");
      }
      if (result?.listItems) {
        this.successResponse.listMembers = this.transform(result?.listItems);
        this.successResponse.pagination = result?.pagination;
        this.items = result?.listItems;
        this.successResponse.state = true;
      }
      if (result?.listPublishStatus) {
        this.successResponse.listPublishStatus = result?.listPublishStatus;
      }
    });
    __publicField(this, "onErrorHandler", (error) => {
      error._messages[0]?.message ? notify(error._messages[0]?.message, "error") : error.message && notify(error.message, "error");
      this.successResponse.state = false;
      this.successResponse.content_id = error.result;
      this.formStatus = PAGE_STATUS.READY;
    });
    __publicField(this, "transform", (data) => {
      return data.map((o) => {
        const date = moment(o[ORGANISATION_MEMBER_FIELD.MODIFIED_TIME]).format("DD MMM, YYYY");
        return {
          member: {
            id: o[ORGANISATION_MEMBER_FIELD.ID],
            name: o[ORGANISATION_MEMBER_FIELD.MEMBER_NAME]
          },
          memberEmail: o[ORGANISATION_MEMBER_FIELD.MEMBER_EMAIL],
          memberRole: o[ORGANISATION_MEMBER_FIELD.MEMBER_ROLE],
          organisation: o[ORGANISATION_MEMBER_FIELD.ORGANISATION],
          lastModified: {
            status: o[ORGANISATION_MEMBER_FIELD.PUBLISHED],
            dateTime: date ?? "",
            author: o[ORGANISATION_MEMBER_FIELD.CREATED_USER_NAME]
          },
          published: {
            state: o[ORGANISATION_MEMBER_FIELD.PUBLISHED],
            id: o[ORGANISATION_MEMBER_FIELD.ID]
          }
        };
      });
    });
    __publicField(this, "deleteMembers", async (arr) => {
      const data = await this.memberStore.delete(arr);
      runInAction(async () => {
        if (!data?.error) {
          await this.initializeData();
          this.onSuccessHandler(data?.response, "Deleted successfully");
        } else {
          this.onErrorHandler(data?.response);
        }
        this.successResponse.state = true;
      });
    });
    __publicField(this, "setPublished", async ({ id, name }, state = 0) => {
      const data = await this.memberStore.update({
        id: id.toString(),
        member_name: name,
        published: state.toString()
      });
      runInAction(async () => {
        if (!data?.error) {
          await this.initializeData();
          this.onSuccessHandler(data?.response, "Updated successfully");
        } else {
          this.onErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "isLoading", () => {
      runInAction(() => {
        this.successResponse.state = false;
      });
    });
    __publicField(this, "callbackOnSuccessGetMembersHandler", (result) => {
      this.successResponse.listMembersWithoutPagination = result?.listItems?.map((o) => {
        let dash = "";
        for (let index = 1; index < o.level; index++) {
          dash += "- ";
        }
        return {
          value: o?.id,
          label: `${dash}${o[ORGANISATION_MEMBER_FIELD.MEMBER_NAME]}`
        };
      });
    });
    makeAutoObservable(this);
    this.memberStore = memberStore;
  }
};
var MemberListViewModel_default = MemberListViewModel;

export {
  MemberListViewModel_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
